import { Add } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import SearchFilterComp from "../../components/shared/SearchFilterComp";
import TabComp from "../../components/shared/TabComp";
import TableComp from "../../components/shared/table/TableComp";
import useAppGlobal from "../../context/useAppGlobal";
import BrandCreate from "./BrandCreate";
import { brandSelectList } from "./utils/constant";
import useBrandAction from "./utils/useBrandAction";
import useBrandBody from "./utils/useBrandBody";
import useAuthGlobal from "src/context/useAuthGlobal";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function BrandTable() {
  const { userMe } = useAuthGlobal();
  const { handleOpenDialog } = useAppGlobal();
  const [sumWhouseId, setSumWHouseId] = useState();
  const [keyWord, setKeyword] = useState();
  const [searchBy, setSearchBy] = useState();
  const [searchValue, setSearchValue] = useState(undefined);
  const action = useBrandAction();
  const permissionCheck = useRoleCheck();

  const { bodyList, header, sortData, isLoading, error, setPagi, pagi, total } = useBrandBody({
    searchBy,
    keyWord,
    brandSelectList,
    searchValue: searchValue ?? undefined,
  });
  const createBrand = () => {
    handleOpenDialog({
      title: "Tạo thương hiệu",
      size: "md",
      content: <BrandCreate />,
    });
  };

  return (
    <Fragment>
      <PageHeader
        name="Quản lý Sản phẩm"
        subName="Thương hiệu"
        value={sumWhouseId}
        setValue={setSumWHouseId}
        item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
        userMe={userMe}
      />

      <Stack
        gap={1.5}
        my={1.5}
      >
        <Button
          disabled={!permissionCheck([PERMISSIONS.CREATE_BRAND])}
          onClick={createBrand}
          variant="contained"
          startIcon={<Add />}
          sx={{ fontSize: "12px", width: "220px" }}
        >
          Thêm thương hiệu
        </Button>
        <Typography sx={{ fontWeight: "bold" }}>{total < 10 ? "0" + total : total} thương hiệu </Typography>

        <TabComp tabs={[{ id: "brands", name: "Thương hiệu" }]} />

        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
          sx={{ width: brandSelectList?.length === 0 ? "35%" : "auto" }}
        >
          <SearchFilterComp
            selectList={brandSelectList}
            getSearchKeyword={setKeyword}
            getSelectKeyword={setSearchBy}
            autoComplete={{
              manufacturer: {
                limit: 20,
                skip: 0,
                endpoint: "/api/v1/manufacturers",
                state: setSearchValue,
                searchField: "name",
              },
            }}
          />
        </Box>
      </Stack>

      <TableComp
        setPagi={setPagi}
        pagi={pagi}
        total={total}
        sortData={sortData}
        bodyList={bodyList}
        headers={header}
        action={action}
        isLoading={isLoading}
        error={error}
      />
    </Fragment>
  );
}
